var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C3.34315 2 2 3.34315 2 5V10C2 11.6569 3.34315 13 5 13H8C9.65685 13 11 11.6569 11 10V5C11 3.34315 9.65685 2 8 2H5ZM4 5C4 4.44772 4.44772 4 5 4H8C8.55228 4 9 4.44772 9 5V10C9 10.5523 8.55228 11 8 11H5C4.44772 11 4 10.5523 4 10V5ZM16 11C14.3431 11 13 12.3431 13 14V19C13 20.6569 14.3431 22 16 22H19C20.6569 22 22 20.6569 22 19V14C22 12.3431 20.6569 11 19 11H16ZM15 14C15 13.4477 15.4477 13 16 13H19C19.5523 13 20 13.4477 20 14V19C20 19.5523 19.5523 20 19 20H16C15.4477 20 15 19.5523 15 19V14ZM2 18C2 16.3431 3.34315 15 5 15H8C9.65685 15 11 16.3431 11 18V19C11 20.6569 9.65685 22 8 22H5C3.34315 22 2 20.6569 2 19V18ZM5 17C4.44772 17 4 17.4477 4 18V19C4 19.5523 4.44772 20 5 20H8C8.55228 20 9 19.5523 9 19V18C9 17.4477 8.55228 17 8 17H5ZM16 2C14.3431 2 13 3.34315 13 5V6C13 7.65685 14.3431 9 16 9H19C20.6569 9 22 7.65685 22 6V5C22 3.34315 20.6569 2 19 2H16ZM15 5C15 4.44772 15.4477 4 16 4H19C19.5523 4 20 4.44772 20 5V6C20 6.55228 19.5523 7 19 7H16C15.4477 7 15 6.55228 15 6V5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBlack);
export default __webpack_public_path__ + "static/media/dashboardBlack.ccf45d87a1620c0a705fa6725d579392.svg";
export { ForwardRef as ReactComponent };